import React from "react";
import ReactDOM from "react-dom/client";
import Classifieds from "./Classifieds";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <Classifieds />
  </React.StrictMode>
);
